// extracted by mini-css-extract-plugin
export default {"content":"Category_content__BVeo6","back":"Category_back__Z4Cra"};